import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { CUSTOMER_BLOCKADE_REGISTRIES_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const createCustomerBlockadeRegistryAction = createAsyncThunk(
    'customer/createCustomerBlockadeRegistryAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.post(CUSTOMER_BLOCKADE_REGISTRIES_PATH, data);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const createCustomerBlockadeRegistrySlice = createSlice({
    name: 'createCustomerBlockadeRegistrySlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(createCustomerBlockadeRegistryAction.pending, () => STATE__API__STARTED);
        builder.addCase(createCustomerBlockadeRegistryAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(createCustomerBlockadeRegistryAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const createCustomerBlockadeRegistryState = (state) => state.customer.createCustomerBlockadeRegistry;
export default createCustomerBlockadeRegistrySlice.reducer;